import {
  PaymentProfile,
  PaymentProfileStatus,
} from '../../models/paymentProfile';

const getPaymentProfileStatus = (
  paymentProfile: PaymentProfile,
  vaultCurrency: string[],
  subscriptionCurrency: string,
  subscriptionPaymentProfileId: number
) => {
  if (!vaultCurrency || !vaultCurrency.includes(subscriptionCurrency)) {
    return PaymentProfileStatus.UNAVAILABLE;
  }
  if (
    paymentProfile.expired ||
    (paymentProfile.creditCard && paymentProfile.creditCard.expired)
  ) {
    return PaymentProfileStatus.EXPIRED;
  }
  if (paymentProfile.id === subscriptionPaymentProfileId) {
    return PaymentProfileStatus.ACTIVE;
  }

  return PaymentProfileStatus.NORMAL;
};

export const serializePaymentProfiles = (
  items: PaymentProfile[],
  vaultCurrencies: Record<string, string[]>,
  subscriptionCurrency: string,
  subscriptionPaymentProfileId: number
) =>
  items.map((paymentProfile: PaymentProfile) => ({
    ...paymentProfile,
    status: getPaymentProfileStatus(
      paymentProfile,
      vaultCurrencies[paymentProfile.vault],
      subscriptionCurrency,
      subscriptionPaymentProfileId
    ),
    isPaymentProfileConnected:
      paymentProfile.id === subscriptionPaymentProfileId,
  }));
